import type { CityConfig } from "../city-template/types";

export const winchesterVaConfig: CityConfig = {
  city: "Winchester",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "winchester-va",
  route: "/winchester-va",
  title: "Emergency Passport Winchester, VA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Winchester, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving the Shenandoah Valley, Frederick County, and the I-81 corridor. Get your passport fast for international travel!",
  h1: "Emergency & Expedited Passport Services in Winchester, VA",
  heroSubtitle: "Passport expired before your Shenandoah Valley trip? Traveling from Frederick County or the northern Shenandoah Valley? We help Winchester travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Historic%20downtown%20Winchester%20Virginia%20with%20the%20charming%20Old%20Town%20pedestrian%20mall%2C%20brick-lined%20sidewalks%2C%20historic%2018th%20and%2019th%20century%20buildings%2C%20and%20the%20Shenandoah%20Valley%20rolling%20hills%20in%20the%20background%2C%20warm%20golden%20afternoon%20light%2C%20professional%20photography%20with%20rich%20colonial-era%20atmosphere%20and%20small-town%20Americana%20charm%2C%20no%20people%20visible%2C%20scenic%20urban%20landscape%20with%20mountain%20valley%20backdrop%20and%20clear%20sky&width=1800&height=700&seq=winchester-va-hero-001&orientation=landscape",
  heroImageAlt: "Historic downtown Winchester Virginia with the Old Town pedestrian mall and Shenandoah Valley backdrop",
  geoPosition: "39.1857;-78.1633",
  geoPlacename: "Winchester, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 75 miles southeast of Winchester via I-66",
  },
  nearbyCitiesZips: [
    { name: "Winchester", zips: "22601, 22602, 22603, 22604" },
    { name: "Martinsburg", zips: "25401, 25402, 25403, 25404, 25405" },
    { name: "Front Royal", zips: "22630" },
    { name: "Leesburg", zips: "20175, 20176, 20177, 20178" },
    { name: "Harrisonburg", zips: "22801, 22802, 22803, 22807" },
    { name: "Charlottesville", zips: "22901, 22902, 22903, 22911, 22936, 22947, 22972, 22974" },
    { name: "Roanoke", zips: "24001, 24002, 24003, 24004, 24005, 24006, 24007, 24008, 24009, 24010, 24011, 24012, 24013, 24014, 24015, 24016, 24017, 24018, 24019, 24020, 24022, 24023, 24024, 24025, 24026, 24027, 24028, 24029, 24030, 24031, 24032, 24033, 24034, 24035, 24036, 24037, 24038, 24040, 24042, 24043, 24044, 24045, 24048, 24050, 24054, 24055, 24059, 24060, 24061, 24062, 24063, 24064, 24065, 24066, 24067, 24068, 24070, 24072, 24073, 24077, 24078, 24079, 24083, 24084, 24085, 24086, 24087, 24088, 24089, 24090, 24091, 24092, 24095" },
    { name: "Strasburg", zips: "22657, 22641" },
    { name: "Woodstock", zips: "22664" },
    { name: "Berryville", zips: "22611" },
    { name: "Charles Town", zips: "25414" },
    { name: "Hagerstown", zips: "21740, 21741, 21742, 21746, 21747, 21748, 21749, 21750" },
    { name: "Fairfax", zips: "22030, 22031, 22032, 22033" },
    { name: "Arlington", zips: "22201, 22202, 22203, 22204, 22205, 22206, 22207, 22209, 22213, 22214, 22217" },
    { name: "Richmond", zips: "23218, 23219, 23220, 23221, 23222, 23223, 23224, 23225, 23226, 23227, 23228, 23229, 23230, 23231, 23233, 23234, 23235, 23236, 23237, 23238, 23242" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent travel departures from the Shenandoah Valley" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Northern Shenandoah Valley Hub", desc: "Serving Winchester, Frederick County, and the I-81 corridor" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Harrisonburg VA passport services", route: "/harrisonburg-va" },
    { name: "Charlottesville VA passport services", route: "/charlottesville-va" },
    { name: "Roanoke VA passport services", route: "/roanoke-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Winchester remotely via secure courier. We do not have a walk-in office in Winchester — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Winchester and northern Shenandoah Valley travelers.",
  fpcOfficeAddress: "1629 K St NW #300, Washington, DC 20006",
  fpcOfficeDistance: "Serving all of Winchester and the surrounding northern Shenandoah Valley including Frederick County, Martinsburg WV, Front Royal, Strasburg, and Berryville",
  serviceAreaIntro: "From the historic brick-lined streets of Old Town Winchester to the quiet neighborhoods of Frederick County, from the Shenandoah University campus to the Apple Blossom festival grounds, from the rolling farmland of the northern Shenandoah Valley to the West Virginia border at Martinsburg — Fast Passport Center serves every corner of Winchester and the northern valley. We regularly help travelers from Martinsburg, Front Royal, Leesburg, Strasburg, and all across the region get their passports fast.",
  nearbyCitiesIntro: "We serve all Winchester neighborhoods and the surrounding northern Shenandoah Valley region including Martinsburg WV, Front Royal, Leesburg, Harrisonburg, Strasburg, Woodstock, Berryville, and Charles Town WV. If you are anywhere in the Winchester area or the broader northern Shenandoah Valley and Potomac region, we have you covered.",
  howItWorksIntro: "Most Winchester travelers complete everything online and ship documents overnight. No need to drive to Washington, DC or wait in line at the regional agency.",
  mistakesIntro: "Winchester travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Winchester and northern Shenandoah Valley travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Winchester? Here are the most common ones we hear from northern Shenandoah Valley travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from Virginia Department of Health Vital Records. Online, mail, or in-person options available for Winchester and Frederick County residents.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through Virginia Department of Health Vital Records. Required for estate, insurance, and legal matters.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Frederick County Circuit Court Clerk. Certified copies available for name changes and legal purposes.", url: "https://www.fcva.us/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Frederick County Circuit Court Clerk. Required for name change passport corrections.", url: "https://www.fcva.us/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Winchester international flights and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Rebecca L.",
      location: "Winchester, VA",
      rating: 5,
      text: "I live in Winchester's Old Town and needed an emergency passport for a business trip to London with 4 days notice. I thought I'd have to drive all the way to DC. Fast Passport Center had my passport in 3 days. I shipped from the UPS on Valley Avenue and it was incredibly easy. No more 2-hour drives to the regional agency for us northern valley folks!",
      service: "Emergency Passport",
    },
    {
      name: "James H.",
      location: "Martinsburg, WV",
      rating: 5,
      text: "As a Martinsburg resident, I thought I was out of luck for expedited passport services. Fast Passport Center made it seamless. They walked me through the acceptance clerk process at the Winchester Post Office and had my renewal in 5 days. The convenience for the West Virginia panhandle and northern Shenandoah Valley is unmatched.",
      service: "Passport Renewal",
    },
    {
      name: "Patricia M.",
      location: "Front Royal, VA",
      rating: 5,
      text: "First passports for my two grandchildren before our family cruise to the Caribbean. Fast Passport Center handled the parental consent requirements and had both passports in 6 days. The convenience for Front Royal families is incredible — we shipped from the UPS on South Street and it was completely hassle-free.",
      service: "Child Passport",
    },
    {
      name: "David K.",
      location: "Winchester, VA",
      rating: 5,
      text: "Lost my passport 48 hours before a conference in Frankfurt. Absolute panic. I live near Shenandoah University and thought I was stranded. Fast Passport Center had a replacement in my hands in 48 hours. They saved my business trip and my company's reputation. Winchester travelers need this service.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "winchester-va-1",
      name: "Winchester Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Winchester",
      state: "VA",
      zip: "22601",
      phone: "(540) 662-4432",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Winchester",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Winchester facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "winchester-va-2",
      name: "Martinsburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Martinsburg",
      state: "WV",
      zip: "25401",
      phone: "(304) 263-5784",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Martinsburg, WV — west of Winchester",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Martinsburg and the West Virginia panhandle. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "winchester-va-3",
      name: "Front Royal Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Front Royal",
      state: "VA",
      zip: "22630",
      phone: "(540) 635-2151",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Front Royal, south of Winchester",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Front Royal and Warren County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "winchester-va-4",
      name: "Harrisonburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Harrisonburg",
      state: "VA",
      zip: "22801",
      phone: "(540) 434-8705",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Harrisonburg, south of Winchester",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Harrisonburg and Rockingham County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "winchester-va-5",
      name: "Frederick County Clerk of Court",
      type: "County Clerk",
      address: "5 N Kent St",
      city: "Winchester",
      state: "VA",
      zip: "22601",
      phone: "(540) 667-5770",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Winchester, downtown area",
      website: "https://www.fcva.us",
      websiteLabel: "Frederick County Clerk",
      notes: "Provides birth certificate and vital records. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
    {
      id: "winchester-va-6",
      name: "Shenandoah University — Student Center",
      type: "Campus Resource",
      address: "1460 University Dr",
      city: "Winchester",
      state: "VA",
      zip: "22601",
      phone: "(540) 665-4500",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Winchester, near I-81",
      website: "https://www.su.edu",
      websiteLabel: "Shenandoah University",
      notes: "Not a passport acceptance facility, but helpful for students. Check with student services for travel document guidance.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive into downtown DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Military & Government", agency: "No special handling", fpc: "Yes — priority for military and government travelers" },
    { feature: "Multi-Application Households", agency: "One slot per application", fpc: "Yes — family batch processing supported" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Winchester photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Shenandoah Valley acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Winchester applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Winchester families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Winchester travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Winchester or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Winchester address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Winchester before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Winchester for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — perfect for last-minute trips from the northern Shenandoah Valley." },
    { q: "How fast can I renew my passport in Winchester?", a: "Fast Passport Center offers fast passport renewal in Winchester in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Winchester?", a: "The nearest regional passport agency to Winchester is the Washington Passport Agency, located approximately 75 miles away in downtown Washington, DC. For urgent processing without navigating the long drive down I-66, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Winchester without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Winchester?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Winchester residents." },
    { q: "Can I expedite a child passport in Winchester?", a: "Yes. Fast Passport Center expedites child passports in Winchester for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Winchester families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Winchester with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "How fast can I get a passport in Winchester?", a: "With Fast Passport Center's emergency courier service, Winchester travelers can receive their passport in as little as 24-48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Winchester?", a: "Popular options include the Winchester Main Post Office (22601), Martinsburg Post Office (25401), Front Royal Post Office (22630), and Harrisonburg Post Office (22801). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Winchester?", a: "Same-day passports are only available at the Washington Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24-48 hour emergency processing is the fastest reliable option — without the DC drive." },
    { q: "What if I live in a smaller northern Shenandoah Valley town?", a: "We serve the entire northern Shenandoah Valley region including Strasburg, Woodstock, Berryville, Front Royal, and the West Virginia panhandle including Martinsburg and Charles Town. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Winchester?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24-48 hour processing, 3-5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
    { q: "Do you help with passport photos in Winchester?", a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx Office locations in Winchester, Martinsburg, and Front Royal offer passport photo services. We review your photos before submission to ensure they meet State Department standards." },
    { q: "What documents do I need for a first-time passport in Winchester?", a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk." },
    { q: "Can you help with a child's passport in Winchester?", a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Winchester families through the entire process and help schedule acceptance clerk appointments." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Winchester", address: "1902 Valley Ave, Winchester, VA 22601", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Winchester", address: "1004 Berryville Ave, Winchester, VA 22601", hours: "Mon-Sun: 7AM-11PM" },
    { name: "FedEx Office — Winchester", address: "2015 S Loudoun St, Winchester, VA 22601", hours: "Mon-Fri: 7AM-9PM, Sat: 8AM-6PM" },
    { name: "CVS Pharmacy — Martinsburg", address: "901 Foxcroft Ave, Martinsburg, WV 25401", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Martinsburg", address: "651 Foxcroft Ave, Martinsburg, WV 25401", hours: "Mon-Sun: 7AM-11PM" },
    { name: "CVS Pharmacy — Front Royal", address: "10 E 14th St, Front Royal, VA 22630", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Front Royal", address: "414 N Royal Ave, Front Royal, VA 22630", hours: "Mon-Sun: 7AM-11PM" },
    { name: "CVS Pharmacy — Harrisonburg", address: "1920 E Market St, Harrisonburg, VA 22801", hours: "Mon-Sun: 8AM-10PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Winchester",
      address: "3295 Valley Ave, Winchester, VA 22601",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Front Royal",
      address: "15 N Shenandoah Ave, Front Royal, VA 22630",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Harrisonburg",
      address: "3280 Carrier Dr, Harrisonburg, VA 22801",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Serves Harrisonburg and Rockingham County. REAL ID available.",
      featured: false,
    },
    {
      name: "West Virginia DMV — Martinsburg",
      address: "2339 Henshaw Rd, Inwood, WV 25428",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Serves Martinsburg and the WV panhandle. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "IAD",
      name: "Dulles International Airport",
      distance: "Approximately 60 miles southeast of Winchester",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "The closest major international airport to Winchester. Flights to Europe, Asia, and worldwide destinations. Accessible via I-81 and I-66.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: true,
    },
    {
      code: "DCA",
      name: "Ronald Reagan Washington National Airport",
      distance: "Approximately 75 miles southeast of Winchester",
      address: "2401 Smith Ave, Arlington, VA 22202",
      note: "Major domestic hub for flights across the U.S. Accessible via I-81 and I-66.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: false,
    },
    {
      code: "HGR",
      name: "Hagerstown Regional Airport",
      distance: "Approximately 30 miles north of Winchester",
      address: "18434 Showalter Rd, Hagerstown, MD 21742",
      note: "Small regional airport with flights to major hubs. Accessible via I-81.",
      flightUrl: "https://www.flyhagerstown.com/",
      flightLabel: "HGR Airport",
      featured: false,
    },
    {
      code: "CHO",
      name: "Charlottesville-Albemarle Airport",
      distance: "Approximately 85 miles south of Winchester",
      address: "1000 Bowen Loop, Charlottesville, VA 22911",
      note: "Regional hub with flights to major domestic hubs. Accessible via I-81.",
      flightUrl: "https://www.gocho.com/",
      flightLabel: "CHO Airport",
      featured: false,
    },
    {
      code: "SHD",
      name: "Shenandoah Valley Regional Airport",
      distance: "Approximately 90 miles south of Winchester",
      address: "77 Aviation Circle, Weyers Cave, VA 24486",
      note: "The regional airport for the broader Shenandoah Valley. Direct flights to major hubs. Accessible via I-81.",
      flightUrl: "https://www.flyshd.com/",
      flightLabel: "SHD Airport",
      featured: false,
    },
  ],
};